import React, {useState} from 'react';
import sponsored from '../data/sponsored';
import SpaceBackground from '../images/sponsored/background-overlay.jpg';
import Plaudy from 'plaudy';

const SponsoredChannels = () => {
  const randomSponsoredIndex = Math.floor(Math.random() * (sponsored.length - 1));
  const featuredChannel = sponsored[randomSponsoredIndex];

  useState(() => {
    Plaudy.track('ad view', {
      advertiser: featuredChannel.name,
      object_id: 'Sponsored Channels',
    });
  }, []);

  return (
    <a href={featuredChannel.link} target="_blank" className="graphic">
      <img src={SpaceBackground} className="banner overlay" alt="banner" />
      <div className="shadow" />
      <div className="card">
        <img src={require(`../images/sponsored/avatars/${featuredChannel.avatar}`)} className="avatar" alt="avatar"/>
        <div className="card-details">
          <h3>{featuredChannel.name}</h3>
          <p>{featuredChannel.subscribers} subscribers</p>
        </div>
      </div>
    </a>
  );
};

export default React.memo(SponsoredChannels);
